export default {
  middleware_url: "https://secib.fluid-it.fr",
  cake_url: "https://secib.cake.fluid-it.fr",
  pwa_url: "https://app.secib.fluid-it.fr",
  isWavesoftEnabled: false,
  isUrbantzEnabled: false,
  billingConforamaEnabled: false,
  showLockBillingButton: true,
  useMapPage: true,
  useGpsTracking: true,
  instancePrefix: "32",
  googleMap: {
    api: "AIzaSyCfbQTQGW30LfzMcWXRFFRgm8cJaYQqEA0",
  },
};
